import React from 'react'
import style from './style'
import injectSheet from 'react-jss'

const Header = ({ classes, title }) =>
  <div className={classes.Header}>
    {title}
  </div>

export default injectSheet(style)(Header)



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/Header/index.js